import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="pwa"
export default class extends Controller {
  static targets = ["installButton"];

  initialize() {
    this.deferredPrompt = null;
  }

  connect() {
    window.addEventListener("beforeinstallprompt", (e) => {
      this.deferredPrompt = e;
      this.installButtonTarget.style.display = "block"; // Show the install button
    });
  }

  install() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt(); // Show the install prompt
      this.deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the A2HS prompt");
        } else {
          console.log("User dismissed the A2HS prompt");
        }
        this.deferredPrompt = null; // Clear the prompt variable
      });
    }
  }
}
